/* eslint-disable max-lines-per-function, max-params, max-lines */
import "./product-details-notify-on-restock-modal.scss";
import { EventBus, Events } from "jiffy-store";
import { api } from "jiffy-api";
import { until, throttle } from "common/utils/helpers/delay";
import { notifyError } from "common/utils/app-monitoring/notify";
import trackers, {
  trackRestockBtn,
  modalClicksTracker,
  sizeClicksTracker
} from "./product-details-notify-on-restock-modal-tracking";

export default async () => {
  const $$modal = $(".js-product-details-notify-on-restock-modal");
  if (!$$modal.length) return;

  let $nextFocus = null;
  const $modalColor = document.querySelector(".js-product-details-notify-on-restock-modal-color");
  const $modalImages = document.querySelectorAll(
    ".js-product-details-notify-on-restock-modal-image"
  );
  const $modalPrices = document.querySelectorAll(
    ".js-product-details-notify-on-restock-modal-prices"
  );
  const $modalClose = document.querySelector(".js-product-details-notify-on-restock-modal-close");
  const $modalGoToSimilarBtn = document.querySelector(
    ".js-product-details-notify-on-restock-modal-go-to-similar-btn"
  );
  const $modalOpen = document.querySelectorAll(".js-product-details-notify-on-restock-modal-open");
  const $unsubscribeBtns = document.querySelectorAll(
    ".js-product-details-notify-on-restock-unsubscribe"
  );

  const $favoriteButton = document.querySelector(".js-product-details-favorite-button");
  const $favoriteIcon = document.querySelector(".js-product-details-favorite-icon");
  const addMonitoredClass = (color, colorBlocks) => {
    const allColorBlocks =
      colorBlocks || document.querySelectorAll(`.js-notify-block[data-color="${color}"]`);
    allColorBlocks.forEach(item => {
      item.classList.add("product-details-quantity-form-row__notify-block--monitored");
    });
  };
  const removeMonitoredClass = (color, colorBlocks) => {
    const allColorBlocks =
      colorBlocks || document.querySelectorAll(`.js-notify-block[data-color="${color}"]`);
    allColorBlocks.forEach(item => {
      item.classList.remove("product-details-quantity-form-row__notify-block--monitored");
    });
  };
  const $toggleSizes = document.querySelector(".js-toggle-sizes");
  const $notifyWrapper = document.querySelector(".js-notify-wrapper");

  trackers();
  const initSizesButtons = wrapper => {
    if (!$toggleSizes) return;

    const buttons = wrapper.querySelectorAll(".js-favorite-size-item");
    // reset state of notes and buttons
    $toggleSizes.checked = true;

    buttons.forEach(button => {
      const { variant } = button.dataset;
      const { favoriteItemId, compositionId } = wrapper.dataset;

      button.addEventListener("click", async () => {
        $notifyWrapper.classList.add("disabled");
        const currentButtons = wrapper.querySelectorAll(
          ".js-favorite-size-item:not(.product-details-notify-on-restock-modal__size-item--deselected)"
        );
        const selectedVariants = Array.from(currentButtons).map(s => +s.dataset.variant);
        const variantIndex = selectedVariants.indexOf(+variant);
        if (variantIndex === -1) {
          selectedVariants.push(+variant);
        } else {
          selectedVariants.splice(variantIndex, 1);
        }
        button.classList.toggle("product-details-notify-on-restock-modal__size-item--deselected");

        const deselectedButtons = wrapper.querySelectorAll(
          ".js-favorite-size-item.product-details-notify-on-restock-modal__size-item--deselected"
        );

        if (deselectedButtons.length > 0) {
          $toggleSizes.checked = false;
          sizeClicksTracker("size_deselected", { size: button.dataset.size });
        } else {
          $toggleSizes.checked = true;
          sizeClicksTracker("size_selected", { size: button.dataset.size });
        }

        try {
          await api.favorites.subscribe({
            favorite_item_id: favoriteItemId,
            composition_id: compositionId,
            variant_ids: selectedVariants
          });
        } finally {
          $notifyWrapper.classList.remove("disabled");
        }
      });
    });
  };

  const createSizesButtons = (color, variants, favoriteItemId, compositionId) => {
    let wrapperBlock = document.querySelector(
      `.js-notify-modal-sizes-wrapper[data-color="${color}"]`
    );
    if (!wrapperBlock) {
      const parent = document.querySelector(".js-notify-wrapper");
      wrapperBlock = document.createElement("div");
      wrapperBlock.classList.add("js-notify-modal-sizes-wrapper");
      parent.appendChild(wrapperBlock);
    }
    wrapperBlock.innerHTML = "";
    wrapperBlock.dataset.variants = variants.map(({ id }) => id).join(", ");
    wrapperBlock.dataset.favoriteItemId = favoriteItemId;
    wrapperBlock.dataset.compositionId = compositionId;
    wrapperBlock.dataset.color = color;

    variants.forEach(variant => {
      const template = `
        <button
          class="product-details-notify-on-restock-modal__size-item js-favorite-size-item"
          data-size="${variant.size}"
          data-variant="${variant.id}"
          type="button"
        >
          ${variant.size}
        </button>`;

      const button = document.createElement("button");
      button.innerHTML = template.trim();

      wrapperBlock.appendChild(button.firstChild);
    });
    initSizesButtons(wrapperBlock);
  };

  const initSelectAllButtons = () => {
    const getWrapper = () => {
      const currentWrapper = document.querySelector(".js-notify-modal-sizes-wrapper:not(.hidden)");
      if (!currentWrapper) {
        return null;
      }

      return currentWrapper;
    };

    $toggleSizes.addEventListener("change", async e => {
      const wrapper = getWrapper();
      if (!wrapper) return;
      const { favoriteItemId, compositionId, variants } = wrapper.dataset;
      const currentButtons = wrapper.querySelectorAll(".js-favorite-size-item");
      const { checked } = e.target;

      const variantsIds = checked ? variants.split(",").map(v => +v) : [];

      try {
        $notifyWrapper.classList.add("disabled");
        await api.favorites.subscribe({
          favorite_item_id: favoriteItemId,
          composition_id: compositionId,
          variants_ids: variantsIds
        });
      } finally {
        $notifyWrapper.classList.remove("disabled");
        if (checked) {
          currentButtons.forEach(btn => {
            btn.classList.remove("product-details-notify-on-restock-modal__size-item--deselected");
          });
          modalClicksTracker("select_all_sizes_select");
        } else {
          currentButtons.forEach(btn => {
            btn.classList.add("product-details-notify-on-restock-modal__size-item--deselected");
          });
          modalClicksTracker("select_all_sizes_deselect");
        }
      }
    });
  };

  const initModalOpen = buttons => {
    buttons.forEach(btn => {
      const parentBlock = btn.parentElement;
      const { color, productId, businessLineId } = parentBlock.dataset;
      const allColorParents = document.querySelectorAll(`.js-notify-block[data-color="${color}"]`);

      btn.classList.add("inited");
      btn.addEventListener("click", async () => {
        $nextFocus = btn.parentElement.querySelector(
          ".js-product-details-notify-on-restock-unsubscribe"
        );
        allColorParents.forEach(item => {
          item.classList.add("disabled");
        });
        $favoriteButton.disabled = true;
        $favoriteIcon.disabled = true;

        try {
          const favoritesData = await api.favorites.addFavoriteItem({
            product_slug: productId,
            ac: color,
            notify_state: "subscribed",
            business_line_id: businessLineId
          });
          if ($toggleSizes)
            createSizesButtons(
              color,
              favoritesData.variants,
              favoritesData.favorite_item_id,
              favoritesData.composition_id
            );
          $$modal.modal("show");
          $$modal.find("button").first().trigger("focus");
          addColorToMonitoredItems(color);
          addMonitoredClass(color, allColorParents);
          $favoriteButton.classList.add("product-details-favorite-button__button--added");
          $favoriteIcon.classList.add("product-details-favorite-icon--added");
        } finally {
          allColorParents.forEach(item => {
            item.classList.remove("disabled");
          });
          $favoriteButton.disabled = false;
          $favoriteIcon.disabled = false;
        }
        trackRestockBtn("notify_on_restock_clicked", color);
      });
    });

    if ($toggleSizes) initSelectAllButtons();
  };

  initModalOpen($modalOpen);

  const unsubscribeHandler = throttle(async (parentBlock, productId, color, allColorParents) => {
    allColorParents.forEach(item => {
      item.classList.add("disabled");
    });

    try {
      await api.favorites.unsubscribeFavoriteItem(
        { ac: encodeURIComponent(color) },
        {
          product_slug: productId,
          business_line_id: parentBlock.dataset.businessLineId
        }
      );

      removeColorFromMonitoredItems(color);
      removeMonitoredClass(color, allColorParents);
    } finally {
      allColorParents.forEach(item => {
        item.classList.remove("disabled");
      });

      parentBlock.querySelector(".js-product-details-notify-on-restock-modal-open")?.focus();
    }

    trackRestockBtn("notify_on_restock_unselect_clicked", color);
  });

  const initUnsubscribe = buttons => {
    buttons.forEach(btn => {
      const parentBlock = btn.parentElement;
      const { color, productId } = parentBlock.dataset;
      const allColorParents = document.querySelectorAll(`.js-notify-block[data-color="${color}"]`);

      btn.classList.add("inited");
      btn.addEventListener(
        "click",
        unsubscribeHandler.bind(null, parentBlock, productId, color, allColorParents)
      );
    });
  };

  initUnsubscribe($unsubscribeBtns);

  const initOnHideModal = () => {
    $$modal.on("hide.bs.modal", event => {
      event.stopPropagation();

      if ($$modal.is(":visible")) {
        modalClicksTracker("close_out_click");
      }
    });
  };

  initOnHideModal();

  $modalClose.addEventListener("click", () => {
    $$modal.modal("hide");
    $nextFocus?.focus();
  });

  $modalGoToSimilarBtn.addEventListener("click", e => {
    e.preventDefault();

    $$modal.modal("hide");
    modalClicksTracker("see_similar_items");
  });

  EventBus.on(Events.MOBILE_GRID_LOADED, () => {
    const newModalOpen = document.querySelectorAll(
      ".js-product-details-notify-on-restock-modal-open:not(.inited)"
    );
    const newUnsubscribeBtns = document.querySelectorAll(
      ".js-product-details-notify-on-restock-unsubscribe"
    );

    initModalOpen(newModalOpen);
    initUnsubscribe(newUnsubscribeBtns);
    initMonitoredFavoriteItems();
  });

  if ($$modal.data("showModal")) {
    const wrapperBlock = document.querySelector(".js-notify-modal-sizes-wrapper");
    initSizesButtons(wrapperBlock);
    $$modal.modal("show");
  }

  const addColorToMonitoredItems = color => {
    // For notify-on-restock, we add for ANY business line context
    // The actual subscription logic will handle the appropriate business line
    if (
      window.jiffy.monitoredFavoriteItems.length > 0 &&
      typeof window.jiffy.monitoredFavoriteItems[0] === "object"
    ) {
      // Check if already monitored in any business line
      const isAlreadyMonitored = window.jiffy.monitoredFavoriteItems.some(
        item => item.name === color
      );
      if (!isAlreadyMonitored) {
        // Add as a placeholder - the actual business line will be determined by the server
        window.jiffy.monitoredFavoriteItems = [
          ...window.jiffy.monitoredFavoriteItems,
          { name: color, business_line: "Unknown" }
        ];
      }
    } else {
      // Backwards compatibility with old format
      window.jiffy.monitoredFavoriteItems = [...window.jiffy.monitoredFavoriteItems, color];
    }
  };

  const removeColorFromMonitoredItems = color => {
    if (
      window.jiffy.monitoredFavoriteItems.length > 0 &&
      typeof window.jiffy.monitoredFavoriteItems[0] === "object"
    ) {
      // Remove from ALL business lines
      window.jiffy.monitoredFavoriteItems = window.jiffy.monitoredFavoriteItems.filter(
        item => item.name !== color
      );
    } else {
      // Backwards compatibility with old format
      window.jiffy.monitoredFavoriteItems = window.jiffy.monitoredFavoriteItems.filter(
        item => item !== color
      );
    }
  };

  const initMonitoredFavoriteItems = () => {
    const $allColorBlocks = document.querySelectorAll(".js-notify-block[data-color]");
    $allColorBlocks.forEach(item => {
      const { color } = item.dataset;
      let isMonitored = false;

      // Handle new format with business line objects
      if (
        window.jiffy.monitoredFavoriteItems.length > 0 &&
        typeof window.jiffy.monitoredFavoriteItems[0] === "object"
      ) {
        // Check if monitored in ANY business line
        isMonitored = window.jiffy.monitoredFavoriteItems.some(
          favoriteItem => favoriteItem.name === color
        );
      } else {
        // Backwards compatibility with old format (array of color names)
        isMonitored = window.jiffy.monitoredFavoriteItems.includes(color);
      }

      if (isMonitored) {
        item.classList.add("product-details-quantity-form-row__notify-block--monitored");
      }
    });
  };

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
    $modalColor.innerHTML = `Color: ${color}`;
    $modalImages.forEach(item => {
      item.classList.toggle("hidden", item.dataset.colorName !== color);
    });

    $modalPrices.forEach(item => {
      item.classList.toggle("hidden", item.dataset.color !== color);
    });

    const sizesWrappers = document.querySelectorAll(".js-notify-modal-sizes-wrapper");
    sizesWrappers.forEach(item => {
      item.classList.toggle("hidden", item.dataset.color !== color);
    });
  });

  EventBus.on(Events.REMOVED_FROM_FAVORITES, (evt, { color }) => {
    if ($(".product-details-quantity-form-row__notify-block--monitored").length) {
      removeColorFromMonitoredItems(color);
      removeMonitoredClass(color);
    }
  });

  EventBus.on(Events.COMPARABLES_LOADED, (evt, { hasComparables }) => {
    if (hasComparables) {
      $modalGoToSimilarBtn.classList.remove("hidden");
    } else {
      $modalGoToSimilarBtn.classList.add("hidden");
    }
  });

  window.jiffy = window.jiffy || {};
  // init immediately when already fetched
  if ("monitoredFavoriteItems" in window.jiffy) {
    initMonitoredFavoriteItems();
  }

  // if being fetched, wait until fetched or reached wait timeout
  if (window.jiffy.fetchingFavoriteItems) {
    const favoriteItemsFetched = await until(() => "monitoredFavoriteItems" in window.jiffy);
    if (favoriteItemsFetched) {
      initMonitoredFavoriteItems();
      return;
    }
  }

  // when currently not fetching the favorite items or has reached wait
  // timeout (not successfully awaited), fallback to fetching favorite
  // items
  window.jiffy.fetchingFavoriteItems = true;
  const $pageContainer = document.getElementById("product-page-container");
  const { productId: productSlug } = $pageContainer?.dataset || {};
  try {
    const data = await api.favorites.getFavoriteItems({
      product_slug: productSlug
    });
    if (data.success) {
      window.jiffy.favoriteItems = data.items;
      window.jiffy.monitoredFavoriteItems = data.monitored_items;
      window.jiffy.fetchingFavoriteItems = false;
      initMonitoredFavoriteItems();
    }
  } catch (error) {
    window.jiffy.fetchingFavoriteItems = false;
    notifyError("Error fetching favorite items", {
      params: {
        error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
        product_slug: productSlug
      }
    });
  }
};
